<template>
  <div id="index">
    <div class="header">
      <div class="headerBox">您好，欢迎来到亳药师！&nbsp;&nbsp;<a v-show="showLogin" @click="goLogin">请登录</a>&nbsp;&nbsp;<a  v-show="showLogin" @click="goRegister">免费注册</a></div>
    </div>
    <div class="user">
      <div class="userBox">
        <h2>亳药师<b>用户注册协议</b></h2>
        <div>
          <p>2022年6月</p>
          <h5><b>尊敬的用户：</b></h5>
          <h5><b>您好！</b></h5>
          <h6>您在注册成为安徽广盛堂中药饮片有限公司网站/平台(以下简称亳药师)用户之前，请事先认真阅读本服务条款中各项内容。当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，
            <b>并与【亳药师】达成一致，成为亳药师平台“用户”。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。</b>
          </h6>
          <h5>
            <b>阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。 本协议由您与毫药师相关服务（网站所涉域名为【boyaoshi,com】，以网站不时更新、确认的域名为准）的经营者共同缔结，本协议具有合同效力。毫药师及相关服务的各业务主体：安徽广盛堂中药饮片有限公司（亳州市亳芜现代产业园区希夷大道西侧、月季路北侧）作为毫药师网站的网络域名及持有者，北京自游侠科技有限公司（北京市门头沟区中门寺街69号45幢870号）为网站提供各项相关软件/程序功能的开发、运维及优化升级技术服务。我们后续可能根据平台运营情况不断调整和更新服务内容，不断调整和更新实际服务提供主体</b>
          </h5>
          <h5><b>※ 重要须知</b></h5>
          <h5><b>1、在使用毫药师提供的软件、网站、客户端、服务（统称为 “毫药师产品或服务”）之前，请您务必认真阅读并充分理解本协议、《法律声明及隐私权政策》以及开通或使用某项服务的附加条款或规则，特别是关于特别提示、个人信息保护、接收邮件及消息、担保与保证、免责及责任限制、争议解决等条款，该类条款可能以粗体或下划线方式进行标识，请您注意重点阅读。</b></h5>
          <h5><b>2、如果您对本条款有疑问，请您通过毫药师客服渠道【电话：0558-5858131】进行询问，毫药师将向您解释本条款内容。一旦您开始使用毫药师产品或服务，即表示您已经理解并同意相关协议，该协议即构成对您具有法律约束力的法律文件。</b></h5>
          <h5><b>3、您声明您有充分的权力、能力和权限来同意和履行本条款。如果您代表第三人同意本条款，您声明您有充分的法律授权使第三人受到本条款的约束。如果您没有充分的法律授权，请您确保由第三人的授权人士来同意本条款。</b></h5>
          <h5><b>4、特别提示</b></h5>
          <h5><b>A）在您使用本平台产品或服务的过程中，我们可能会基于您需求的服务，收集和使用您的个人信息，包括您的位置信息、设备信息，部分功能中还会包括您的身份信息、联系方式及交易信息。请您认真阅读《法律声明及隐私权政策》并在确认同意后使用相关服务。</b></h5>
          <h5><b>B）《法律声明及隐私权政策》介绍了您在使用我们的服务时，我们会如何处理您的个人信息及数据。请您务必认真阅读，在确认充分了解并同意后使用毫药师平台产品或服务。</b></h5>
          <h5><b>C）当您使用本平台产品或服务，即表示您信赖我们对您的信息的处理方式，并已同意本平台服务条款及隐私权政策等服务协议中关于您的信息收集及使用的条款。</b></h5>
          <h5><b>5、接收邮件、消息</b></h5>
          <h5><b>A）毫药师可能会通过您的手机号码、电子邮件或其他联系方式向您发送短信、邮件或消息（包括但不限于活动、促销、广告、宣传或其他商业信息）。</b></h5>
          <h5><b>B）如果您不再同意毫药师向您发送上述短信、邮件与消息，请您以退订短信或电子邮件或以书面形式明确告知毫药师。</b></h5>
          <h5><b>一、注册资格</b></h5>
          <h5> 您确认，在您开始注册程序使用“亳药师”平台服务前，您应当具备中华人民共和国法律规定的与您行为相适应的民事行为能力，
            <b>如您为未成年人，请您务必在您的监护人仔细阅读本平台服务条款并同意的前提下使用我们的产品或服务或向我们提供信息。 </b>
            若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的一切后果。
          </h5>
          <h5> 此外，您还需确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则您可能无法正常注册及使用“亳药师”平台服务。 </h5>
          <h5>如果您代表公司或其他单位使用“亳药师”网站所提供的服务，您应当在此向安徽广盛堂中药饮片有限公司承诺您有权代表该公司或单位，您对本协议的接受将被自动视为您所代表的公司或单位对本协议的接受。</h5>
          <h5><b>二、服务名称及内容</b></h5>
          <h5>您有权享受安徽广盛堂中药饮片有限公司及旗下网站(“亳药师”中药材价格指数、在线询盘报价、资讯信息等服务，）具体您可以登录“亳药师”平台浏览。</h5>
          <h5><b>三、服务须知</b></h5>
          <h5><b>3.1 用户须知</b></h5>
          <h5>1)     自行配备上网的所需设备，包括个人电脑或其它必备上网装置。</h5>
          <h5>2)     自行申请宽带上网接入服务(如ADSL、LAN等)。</h5>
          <h5><b>3.2 账户说明</b></h5>
          <h5>【账户获得】当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，您可获得“亳药师”账户并成为【亳药师】平台用户。</h5>
          <h5><b>注意：未经他人许可不得用他人名义（包括但不限于冒用他人姓名、名称、字号、头像等足以让人引起混淆的方式）开设账号，不得恶意注册“亳药师”账号（包括但不限于频繁注册、批量注册账号等行为）。本公司有权对您提交的信息进行审核。</b></h5>
          <h5>【账户使用】您有权使用您设置或确认的手机号码（以下简称“账户名称”）及您设置的密码登录亳药师平台。您的账号仅限本人使用，未经亳药师平台同意，不可自主进行账号转让，否则亳药师平台有权追究您的违约责任，且由此产生的一切责任均由您承担。</h5>
          <h5>【实名认证】作为亳药师平台用户，为您更好地使用亳药师平台的各项服务（如：药材供求信息等），要求您按安徽广盛堂中药饮片有限公司要求及我国法律规定完成实名认证或企业认证。</h5>
          <h5><b>3.3 注册信息管理</b></h5>
          <h5>【信息真实】在使用亳药师平台服务时，您应当按亳药师城平台页面的提示准确完整地提供您的信息（包括您的姓名及联系电话、联系地址等），以便亳药师平台或其他用户与您联系。您有义务保持您提供信息的真实性及有效性。</h5>
          <h5>【会员名的合法性】您设置的亳药师会员名不得违反国家法律法规及亳药师关于会员名的管理规定，且不得含有任何威胁、恐吓、漫骂、庸俗、亵渎、色情、淫秽、非法、前后矛盾、攻击性、伤害性、骚扰性、诽谤性、辱骂性的或侵害他人知识产权的文字，否则可回收您的亳药师会员名。</h5>
          <h5>【更新维护】您应当及时更新您提供的信息，在法律有明确规定要求亳药师作为平台服务提供者必须对部分用户（供求信息发布者等）的信息进行核实的情况下，亳药师平台将依法不时地对您的信息进行检查核实，您应当配合提供最新、真实、完整、有效的信息。</h5>
          <h5>如您未按亳药师平台的要求及时提供信息、您提供的信息存在明显不实或行政司法机关核实您提供的信息无效的，您将承担因此对您自身、他人及亳药师平台造成的全部损失与不利后果。亳药师平台可向您发出询问或要求整改的通知，并要求您进行重新认证，直至中止、终止对您提供部分或全部亳药师平台服务，亳药师平台对此不承担责任。</h5>
          <h5><b>3.4 账户安全规范</b></h5>
          <h5><b>【账户安全保管义务】您的账户为您自行设置并由您保管。毫药师任何时候均不会主动要求您提供您的账户密码。因此，建议您确保您在每个上网时段结束时退出登录并以正确步骤离开毫药师平台。</b></h5>
          <h5>用户的密码和帐号遭到未授权的使用或发生其他任何安全问题，用户可以立即通知亳药师平台，并且用户在每次连线结束，应结束帐号使用，否则用户可能得不到亳药师平台的安全保护。对于用户长时间未使用的帐号，亳药师有权予以关闭。因此，建议您务必保管好您的账户。</h5>
          <h5>账户因您主动泄露或因您遭受他人攻击、诈骗等行为导致的损失及后果，亳药师平台并不承担责任，您应通过司法、行政等救济途径向侵权行为人追偿。</h5>
          <h5>【账户行为责任自负】除亳药师平台存在过错外，您应对您账户项下的所有行为结果（包括但不限于在线签署各类协议、需求方报价服务等）负责。</h5>
          <h5><b>3.5 责任限制</b></h5>
          <h5>【海量信息】亳药师平台仅向您提供亳药师平台服务，您应了解亳药师平台上的信息是用户自行发布，且可能存在风险和瑕疵。亳药师平台将通过依法建立相关检查监控制度尽可能保障您在亳药师平台上的合法权益及良好体验。
            <b>同时，鉴于亳药师平台具备存在海量信息及信息网络环境下信息与实物相分离的特点，亳药师平台无法逐一审查商品及服务的信息和服务的质量；安全以及合法性、真实性、准确性，对此您应谨慎判断。 </b>
          </h5>
          <h5><b>【调处决定】您理解并同意，在争议调处服务中，亳药师平台的客服、评审员并非专业人士，仅能以普通人的认知对用户提交的凭证进行判断。因此，除存在故意或重大过失外，调处方对争议调处决定免责。</b></h5>
          <h5><b>3.6 用户信息的保护及授权</b></h5>
          <h5>【信息的发布】您声明并保证，您对您所发布的信息拥有相应、合法的权利，对所有上传、发布到亳药师平台网站的内容，拥有或取得了所有必要的权利并承担全部的法律责任，包括但不限于：用户有权或已取得必要的许可、授权、准许来使用所有与上传作品有关的所有专利、商标、商业秘密、版权、表演者权及其他私有权利。否则，亳药师平台可对您发布的信息依法或依本协议进行删除或屏蔽。</h5>
          <h5><b>【禁止性信息】您应当确保您所发布的信息不包含以下内容：</b></h5>
          <h5>1)     违反国家法律法规禁止性规定的；</h5>
          <h5>2)     政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</h5>
          <h5>3)     欺诈、虚假、不准确或存在误导性的；</h5>
          <h5>4)     侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的；</h5>
          <h5>5)     侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的；</h5>
          <h5>6)     存在可能破坏、篡改、删除、影响亳药师平台任何系统正常运行或未经授权秘密获取亳药师平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的；</h5>
          <h5>7)     其他违背社会公共利益或公共道德或依据相关亳药师平台协议、规则的规定不适合在亳药师平台上发布的。</h5>
          <h5>【授权使用】对于您提供、发布及在使用亳药师平台服务中形成的除个人信息外的文字、图片、视频、音频等非个人信息，在法律规定的保护期限内，您将免费授予安徽广盛堂中药饮片有限公司旗下的亳药师网站及客户端获得许可使用权利及再授权给其他第三方使用并可以自身名义对第三方侵权行为取证及提起诉讼的权利。您同意安徽广盛堂中药饮片有限公司存储、使用、复制、修订、编辑、发布、展示、翻译、分发您的非个人信息或制作其派生作品，并以已知或日后开发的形式、媒体或技术将上述信息纳入其它作品内。若因合作与利用而发生用户的信息内容违法、侵权等纠纷或问题，用户单独承担全部法律责任。</h5>
          <h5><b>3.7用户的违约及处理</b></h5>
          <h5> 1） 违约认定</h5>
          <h5>发生如下情形之一的，视为您违约：</h5>
          <h5>a)     使用亳药师平台服务时违反有关法律法规规定的；</h5>
          <h5>b)     违反本协议或本协议补充协议约定的。 </h5>
          <h5>为适应中药数字信息发展和满足海量用户对高效优质服务的需求，您理解并同意，亳药师平台规则中约定违约认定的程序和标准。如：亳药师平台可依据您的用户数据与海量用户数据的关系来认定您是否构成违约；您有义务对您的数据异常现象进行充分举证和合理解释，否则将被认定为违约。</h5>
          <h5>2） 违约处理措施 </h5>
          <h5>【信息处理】您在亳药师平台上发布的信息构成违约的，亳药师平台可根据相应规则立即对相应信息进行删除、屏蔽处理或对您的商品进行下架、监管。 </h5>
          <h5>【行为限制】您在亳药师平台上实施的行为，或虽未在亳药师平台上实施但对亳药师城平台及其用户产生影响的行为构成违约的，亳药师平台可依据相应规则对您执行账户终止向您提供部分或全部服务等处理措施。如您的行为构成根本违约的，亳药师平台查封您的账户，终止向您提供服务。</h5>
          <h5>【处理结果公示】亳药师平台可将对您上述违约行为处理措施信息以及其他经国家行政或司法机关生效法律文书确认的违法信息在亳药师平台上予以公示。 </h5>
          <h5>3） 特别约定 </h5>
          <h5>【商业贿赂】如您向安徽广盛堂中药饮片有限公司及其关联公司的雇员或顾问等提供实物、现金、现金等价物、劳务、旅游等价值明显超出正常商务洽谈范畴的利益，则可视为您存在商业贿赂行为。发生上述情形的，亳药师平台可立即终止与您的所有合作并向您收取违约金及/或赔偿金，该等金额以亳药师平台因您的贿赂行为而遭受的经济损失和商誉损失作为计算依据。</h5>
          <h5><b>四、协议的变更 </b></h5>
          <h5><b>亳药师平台可根据国家法律法规变化及维护交易秩序、保护消费者权益需要，不时修改本协议、补充协议，变更后的协议、补充协议（下称“变更事项”）。变更事项将会在第一时间以妥当的方式（包括但不限于系统提示、公告、站内信等）提示所有注册用户。</b></h5>
          <h5><b>如您不同意变更事项，您有权于变更事项确定的生效日前联系亳药师平台反馈意见。如反馈意见得以采纳，亳药师平台将酌情调整变更事项。</b></h5>
          <h5><b>如您对已生效的变更事项仍不同意的，您应当于变更事项确定的生效之日起停止使用亳药师平台服务，变更事项对您不产生效力；如您在变更事项生效后仍继续使用亳药师平台服务，则视为您同意已生效的变更事项。</b></h5>
          <h5><b>五、协议的终止</b></h5>
          <h5><b>5.1 终止的情形</b></h5>
          <h5>【用户发起的终止】您有权通过以下任一方式终止本协议：</h5>
          <h5>1)     在满足亳药师平台网公示的账户注销条件时您通过网站自助服务注销您的账户的；</h5>
          <h5>2)     变更事项生效前您停止使用并明示不愿接受变更事项的；</h5>
          <h5>3)     您明示不愿继续使用亳药师平台服务，且符合亳药师平台网终止条件的。</h5>
          <h5>【亳药师平台发起的终止】出现以下情况时，亳药师平台可执行以下几条所列的方式通知您终止本协议：</h5>
          <h5>1)     您违反本协议约定，亳药师依据违约条款终止本协议的；</h5>
          <h5>2)     您盗用他人账户、发布违禁信息、骗取他人财物、售假、扰乱市场秩序、采取不正当手段谋利等行为，亳药师平台依据平台规则对您的账户予以查封的；</h5>
          <h5>3)     除上述情形外，因您多次违反亳药师平台规则相关规定且情节严重，亳药师平台依据规则对您的账户予以查封的；</h5>
          <h5>4)     您的账户被亳药师平台依据本协议回收的；</h5>
          <h5>5)     您在平台有欺诈、发布或销售假冒伪劣/侵权商品、侵犯他人合法权益或其他严重违法违约行为的；</h5>
          <h5>6)     其它应当终止服务的情况。</h5>
          <h5><b>5.2 协议终止后的处理</b></h5>
          <h5>【用户信息披露】本协议终止后，除法律有明确规定外，亳药师平台无义务向您或您指定的第三方披露您账户中的任何信息。</h5>
          <h5>【亳药师权利】本协议终止后，亳药师平台仍享有下列权利：</h5>
          <h5>1)     继续保存您留存于亳药师平台的各类信息；</h5>
          <h5>2)     对于您过往的违约行为，亳药师平台仍可依据本协议向您追究违约责任。</h5>
          <h5><b>六、免责声明</b></h5>
          <h5><b>您理解并同意，“亳药师”软件及相关服务可能会受多种因素的影响或干扰，公司不保证(包括但不限于)：</b></h5>
          <h5>6.1 “亳药师”软件及相关服务完全适合用户的所有使用要求；</h5>
          <h5>6.2 “亳药师”软件及相关服务不受干扰，及时、安全、可靠或不出现任何错误；您经由公司取得的任何软件、服务或其他材料符合用户的期望；</h5>
          <h5>6.3 “亳药师”软件及相关服务中任何错误都将能得到更正。</h5>
          <h5>6.4  如有涉嫌借款或其他涉财产的网络信息、账户密码、广告或推广等信息，请您谨慎对待并自行进行判断，您因此遭受的利润、商业信誉、资料损失或其他有形或无形损失，公司不承担任何直接、间接、附带、特别、衍生性或惩罚性的赔偿责任。</h5>
          <h5>6.5 您理解并同意，在使用“亳药师”软件及相关服务过程中，可能遇到不可抗力等因素（不可抗力是指不能预见、不能克服并不能避免的客观事件），包括但不限于自然灾害(如洪水、地震、台风等)、政府行为、战争、罢工、骚动、暴乱等。出现不可抗力情况时，公司将努力在第一时间及时修复，但因不可抗力造成的损失，公司在法律法规范围内免于承担责任。</h5>
          <h5>6.6 公司依据本协议约定获得处理违法违规内容的权利，该权利不构成公司的义务或承诺，公司不能保证及时发现违法行为或进行相应处理。</h5>
          <h5>6.7 您理解并同意，关于“亳药师”软件及相关服务，公司不提供任何种类的明示或暗示担保或条件，包括但不限于商业适售性、特定用途适用性等。您对“亳药师”软件及相关服务的使用行为需自行承担相应风险。</h5>
          <h5>6.8 您理解并同意，本协议是在保障遵守国家法律法规、维护公序良俗，保护他人合法权益，公司在能力范围内尽最大的努力按照相关法律法规进行判断，但并不保证公司判断完全与司法机关、行政机关的判断一致，如因此产生的后果您已经理解并同意自行承担。</h5>
          <h5>6.9 毫药师仅提供药材信息展示服务，不进行交易促成，也不对您以及您所代表的公司与买方/卖方在线上、线下达成的交易意向或交易本身提供任何形式的担保。您以及您所代表的公司与买方/卖方在线下达成交易的过程所产生的争议、纠纷、诉讼，毫药师对此均不承担任何责任。</h5>
          <h5>6.10 在任何情况下，公司均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因您使用“亳药师”软件及相关服务而遭受的利润损失，承担责任。公司对您承担的全部责任，无论因何原因或何种行为方式，始终不超过您在成员期内因使用“亳药师”软件及相关服务而支付给公司的费用(如有)。</h5>

          <h5><b>七、法律适用、管辖与其他</b></h5>
          <h5>【法律适用】本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国大陆地区法律；如法律无相关规定的，参照商业惯例或行业惯例。</h5>
          <h5>【管辖】您因使用亳药师平台服务所产生及与亳药师平台服务有关的争议，由安徽广盛堂中药饮片有限公司与您协商解决。协商不成时，任何一方均可向被告所在地有管辖权的人民法院提起诉讼。</h5>
          <h5>【可分性】本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</h5>
          <h5>【法律声明及隐私政策】法律声明及隐私政策作为本协议的附件，与本协议具有同等效力。</h5>
          <h5 style="text-align:center;margin:0 auto 20px"><button @click="goRegister">我同意</button></h5>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="footer">
      <div class="foot">
        <ul>
          <li>电话：0558-5858131</li>
          <li>地址：亳州市谯城区亳芜现代产业园区希夷大道与月季路交叉口</li>
          <li>安徽广盛堂中药饮片有限公司 版权所有 免责声明 皖ICP备18026442号</li>
          <li>皖公网安备 3416020200060号</li>
        </ul>
        <img src="../assets/img/footerImg.jpg" alt="">
      </div>
    </div>
    <Login ref="login"></Login>
    <Register ref="register"></Register>
  </div>
</template>
<script>
import Login from '../components/login'
import Register from '../components/register'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  components: {
    Login,
    Register,
    vueSeamlessScroll
  },
  data() {
    return {
      morenDiv:true,
      showLogin:true,
      EWMImg:false,
      EWMButton:true,
    }
  },
  mounted() {
  },
  methods: {
    goLogin(){
      this.$refs.login.toLogin();
    },
    goRegister(){
      this.$refs.register.toRegister();
      this.$refs.register.checked = true
    },
  }
}
</script>
<style>
  @import "../assets/css/style.css";
</style>



// WEBPACK FOOTER //
// src/components/userAgreement.vue